import { PageEnum } from '@/models/page.enum';

export class BannerSectionModel {
  public externalId: string;
  public name: string;
  public type: PageEnum;
}
